module.exports = __webpack_public_path__ + "img/logo_bianco.c6114858.png";